<template>
  <v-form>
      <!-- Partie informations personnelles -->
       <v-expansion-panels multiple v-model="Panel.Principal" readonly>
        <v-expansion-panel ref="infosperso">
          <v-expansion-panel-header><h3>
            <!-- Label plus gros et souligné -->
            {{ $storeUniversite.label.InfoPerso }}
          </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="$storeUniversite.inscription.Genre"
                  :items="$storeCatalogue.Genre"
                  :label="$storeUniversite.label.Genre"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  dense
                  :disabled="true"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  disabled
                  v-model="$storeUniversite.inscription.Prenom"
                  :label="$storeUniversite.label.Prenom"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  disabled
                  v-model="$storeUniversite.inscription.Nom"
                  :label="$storeUniversite.label.Nom"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.PaysDeNaissance"
                  :items="$storeCatalogue.Pays"
                  :label="$storeUniversite.label.PaysNaissance"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.Nationalite2"
                  :items="$storeCatalogue.Pays"
                  :label="$storeUniversite.label.Nationalite2"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  disabled
                  v-model="$storeUniversite.inscription.NumCniPasseport"
                  :label="
                    $storeUniversite.inscription.PaysDeResidence ===
                    this.$storeCatalogue.DataId.Maroc
                      ? $storeUniversite.label.CIN
                      : $storeUniversite.label.NumPassport
                  "
                ></v-text-field>
              </v-col>
            </v-row>			
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  disabled
                  v-model="myDateFormated"
                  :label="$storeUniversite.label.DateDeNaissance"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="4" 
              v-if="$storeUniversite.inscription.PaysDeNaissance === $storeCatalogue.DataId.Maroc
                && !$storeUniversite.inscription.PrecisionVilleNaissance">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.VilleNaissance"
                  item-text="lang00"
                  item-value="lang00"
                  :items="$storeCatalogue.VilleMaroc"
                  :label="$storeUniversite.label.VilleNaissance"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="!$storeUniversite.inscription.VilleNaissance">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.PrecisionVilleNaissance"
                  :label="$storeUniversite.label.PrecisionVilleNaissance"
                  disabled
                ></v-text-field>
              </v-col>

            </v-row>			
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.EtrangerResidantAuMaroc"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.ResidentEtrangeMaroc"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.SituationDeHandicap"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.Handicap"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="$storeUniversite.inscription.SituationDeHandicap === $storeCatalogue.DataId.Oui">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.TypeDHandicap"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.NatureHandicap"
                  :label="$storeUniversite.label.NatureHandicap"
                  disabled
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="false">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.EmployeEtatMarocain"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.EmployeEtatMarocain"
                  disabled
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.DemandeBourseSociale"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.DemandeBourseSociale"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.StatutRefugie"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :label="$storeUniversite.label.StatutRefugie"
                  disabled
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="sprotifHautNiveau">
          <v-expansion-panel-header>
            <h3>
              <!-- Label plus gros et souligné -->
              {{ $storeUniversite.label.SportifHautNiveau }}
            </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.SportifHautNiveau"
                  :label="$storeUniversite.label.EtesVousSportifHautNiveau"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  disabled
                ></v-autocomplete>
              </v-col>
               <v-col cols="12" md="4" v-if="$storeUniversite.inscription.SportifHautNiveau === $storeCatalogue.DataId.Oui">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.Disciplines"
                  :label="$storeUniversite.label.Discipline"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.DisciplineSportive"
                  disabled
                  multiple
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="infospostales" >
          <v-expansion-panel-header>
            <h3>
              <!-- Label plus gros et souligné -->
              {{ $storeUniversite.label.InformationPostal }}
            </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.PaysDeResidence"
                  :label="$storeUniversite.label.PaysResidence"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Pays"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.Tel"
                  :label="$storeUniversite.label.Telephone"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row 
            v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AdresseAuMaroc"
                  :label="$storeUniversite.label.Addresse"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row 
            v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.Adresse2"
                  :label="$storeUniversite.label.Addresse2"
                  
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row 
            v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.CodePostal"
                  :label="$storeUniversite.label.CodePostal"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.VilleMaroc"
                  :label="$storeUniversite.label.Ville"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence === $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.ProvinceMA"
                  :label="$storeUniversite.label.District"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Province"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  dense
                  v-model="$storeUniversite.inscription.RegionMA"
                  :label="$storeUniversite.label.Region"
                  :item-text="$storeUniversite.itemLang"
                  item-value="id"
                  :items="$storeCatalogue.Region"
                  disabled
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreAdresse"
                  :label="$storeUniversite.label.Addresse"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>  
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreAdresse2"
                  :label="$storeUniversite.label.Addresse2"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>  
            <v-row v-if="$storeUniversite.inscription.PaysDeResidence !== $storeCatalogue.DataId.Maroc">
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreVille"
                  :label="$storeUniversite.label.Ville"
                  
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  v-model="$storeUniversite.inscription.AutreCodePostal"
                  :label="$storeUniversite.label.CodePostal"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>  
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="programmes">
          <v-expansion-panel-header>
            <h3>{{$storeUniversite.label.TitreListeProgs}}</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-list>
                <v-list-item
                v-for="program in this.$storeUniversite.inscription.ListeProgrammesUm6p"
                :key="program.idCrypte"
                >
                  <v-list-item-content>
                    {{ $storeUniversite.label.ChoixProg + " " +program.noOrdre + " : "+ program.label }}
                    <div
                    v-show="program.listeSpecialitesVue.length > 0"
                    class="bloc-specialites">
                      <br/>
                      <h4 style="color:#d46b2b">Liste des spécialités sélectionnées : </h4>
                      <br/>
                      <v-row v-for="specialite in program.listeSpecialitesVue"
                      :key="specialite.idCrypte">
                        <v-col cols="12" md="12">
                          {{ $storeUniversite.label.ChoixProg + " " + specialite.noOrdre + " : " + specialite.label }}
                        </v-col>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel ref="baccalaureat">
        <v-expansion-panel-header>
          <h3>
            {{ $storeUniversite.label.InformationBac }}
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.TypeDeBac"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.TypeBac"
                :label="$storeUniversite.label.TypeDeBac"
                
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .AnneeDObtentionDuBaccalaureatOuEspere
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.AnneeScolaire"
                :label="$storeUniversite.label.AnneeObtentionBac"
                
                disabled
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.TypeBacAutre"
                :label="$storeUniversite.label.TypeDeBacAutre"
                
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .CodeMassarCodeNationalEtudiant
                "
                :label="$storeUniversite.label.CodeEtudiant"
                
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .ConfirmCodeMassarCodeNationalEtudiant
                "
                :label="$storeUniversite.label.ConfirmCodeEtudiant"
                
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.DomaineBacFr"
                :label="$storeUniversite.label.FiliereDuBac"
                
                disabled
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.TypeDEtablissement
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.TypeEtablissementPublicPrive"
                :label="$storeUniversite.label.TypeEtablissement"
                
                disabled
              ></v-autocomplete>
            </v-col>
             <v-col
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !=
                $storeCatalogue.DataId.TypeBacMarocain
              "
              cols="12"
              md="6"
            >
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.PaysDuLycee"
                :label="$storeUniversite.label.PaysLycee"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                outlined
                disabled
                class="asterisk"

              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ==
                $storeCatalogue.DataId.TypeBacAutre || $storeUniversite.inscription.InfosBac.TypeDeBac ==
                $storeCatalogue.DataId.TypeBacFrancais
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.VilleDuLycee"
                :label="$storeUniversite.label.VilleEtablissement"
                
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-else>
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.VilleDuLycee"
                item-text="lang00"
                item-value="lang00"
                :items="$storeCatalogue.VilleMaroc"
                :label="$storeUniversite.label.VilleEtablissement"
                
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !=
                $storeCatalogue.DataId.TypeBacMarocain
              "
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NomDuLycee"
                :label="$storeUniversite.label.NomEtablissement"
                
                disabled
              ></v-text-field>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.Lycee"
                item-text="label"
                item-value="idCrypte"
                :items="$storeCatalogue.EtablissementMaroc"
                :label="$storeUniversite.label.NomEtablissement"
                
                disabled
              ></v-autocomplete>
            </v-col>
            
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacMarocain
            "
          >
            <v-col cols="12" md="4">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.AutreVilleLycee"
                :label="$storeUniversite.label.VilleEtablissementAutre"
                
                disabled
                v-if="!$storeUniversite.inscription.InfosBac.VilleDuLycee"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NomDuLycee"
                :label="$storeUniversite.label.NomEtablissementAutre"
                
                disabled
                v-if="!$storeUniversite.inscription.InfosBac.Lycee"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .AvezVousObtenuVotreDiplome
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :label="$storeUniversite.label.ObtentionBac"
                
                disabled
                v-if="
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.PostBac
                  ) >= 0
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-if="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacMarocain
                "
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .SystemeNotationBac
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.SystemeNotationBac"
                :label="$storeUniversite.label.SystemeNotationBac"
                disabled
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.BaremBac"
                :label="$storeUniversite.label.BaremeNote"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .SpecificationDuBaremeDeBac
                "
                :label="$storeUniversite.label.SpecificationBaremBac"
                
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="
                $storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <p>{{ $storeUniversite.label.Abcd }}</p>
            </v-col>
            <v-col
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui ||
                $storeUniversite.inscription.NiveauDEtude.indexOf(
                  $storeCatalogue.DataId.PostBac
                ) < 0
              "
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.MoyGenDuBac"
                :label="$storeUniversite.label.MoyGenAnnuelleBac"
                
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6"> </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
            <!-- NOTES LYCEE POST BAC -->
      <v-expansion-panel ref="noteslycee"
        v-if="
          $storeUniversite.inscription.NiveauDEtude.indexOf(
            $storeCatalogue.DataId.PostBac
          ) >= 0">
        <v-expansion-panel-header>
          <h3>
            {{ $storeUniversite.label.ReleveNoteBac }}
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.AutreBac
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.Moy1erAnneeBac"
                :label="$storeUniversite.label.Moyenne1erAnneBac"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-else>
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .MoyGen2EmeAnneeCycleLycee
                "
                :label="$storeUniversite.label.MoyGen2eCycleLycee"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.MoyenneSem1Trim1Bac"
                :label="$storeUniversite.label.MoyenneSem1Trim1Bac"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- BAC FRANCAIS -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacFrancais
            "
          >
            <!-- SPECIALITE 1 -->
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.Specialite1"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.Specialite1Bac"
                :label="$storeUniversite.label.Spécialite1"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NoteSpecialite1"
                :label="$storeUniversite.label.Specialite1note"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC FRANCAIS -->
          <!-- SPECIALITE 2 -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacFrancais
            "
          >
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.Specialite2"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.Specialite2Bac"
                :label="$storeUniversite.label.Specialite2"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NoteSpecialite2"
                :label="$storeUniversite.label.Specialite2note"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC FRANCAIS -->
          <!-- MATH EXPERT OPTION -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacFrancais
            "
          >
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.MathsExpertOption
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :label="$storeUniversite.label.MathsExpertOption"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui &&
                $storeUniversite.inscription.InfosBac.MathsExpertOption ===
                  $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.NoteMathsExpertOption
                "
                :label="$storeUniversite.label.MathsExpertNote"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC MAROCAIN -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacMarocain
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NoteBacRegional"
                :label="$storeUniversite.label.MoyenneExamenRegional"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6"
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.NoteDuBacNational
                "
                :label="$storeUniversite.label.MoyenneNationalBac"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC MAROCAIN OU AUTRE ET DOMAINE AUTRE -->
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math1erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math1BacSem1
                    : $storeUniversite.label.Math1BacSem1Autre
                "
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math1erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math1BacSem2
                    : $storeUniversite.label.Math1BacSem2Autre
                "
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.Maths1ErBacTrim3"
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math1BacTrimestre3
                    : $storeUniversite.label.Math1BacTrimestre3
                "
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math2erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math2BacSem1
                    : $storeUniversite.label.Math2BacSem1Autre
                "
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math2erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math2BacSem2
                    : $storeUniversite.label.Math2BacSem2Autre
                "
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Maths2EmeBacTrim3
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Maths2BacTrim3
                    : $storeUniversite.label.Maths2BacTrim3Autre
                "
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="12" v-if="($storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui)
                && $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacAutre  
              ">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.MathsNational"
                :label="$storeUniversite.label.MathNational"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique1erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique1BacSem1
                    : $storeUniversite.label.Physique1BacSem1Autre
                "
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique1erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique1BacSem2
                    : $storeUniversite.label.Physique1BacSem2Autre
                "
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique1ErBacTrim3
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique1BacTrim3
                    : $storeUniversite.label.Physique1BacTrim3
                "
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique2erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique2BacSem1
                    : $storeUniversite.label.Physique2BacSem1Autre
                "
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique2erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique2BacSem2
                    : $storeUniversite.label.Physique2BacSem2Autre
                "
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="$storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique2EmeBacTrim3
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique2BacTrim3
                    : $storeUniversite.label.Physique2BacTrim3Autre
                "
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="12" v-if="($storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui)
                && $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacAutre  
              ">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.PhysiqueNational"
                :label="$storeUniversite.label.PhysiqueNational"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain 
                && $storeUniversite.inscription.InfosBac.AvezVousObtenuVotreDiplome ===
                 $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.MoyenneCcAnneeBac"
                :label="$storeUniversite.label.MoyenneCcAnneeBac"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
       </v-expansion-panels>
    <br/>
    <v-expansion-panels
      multiple readonly
      v-model="Panel.EtudesSuperieures"
      v-if="
        $storeUniversite.inscription.NiveauDEtude.indexOf(
          $storeCatalogue.DataId.PostBac
        ) < 0
      "
    >
      <v-expansion-panel ref="etudessup">
        <v-expansion-panel-header>
          <h3>
            {{ $storeUniversite.label.InformationLicence }}
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.FiliereIng"
                :label="$storeUniversite.label.DiplomeActuel"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :label="$storeUniversite.label.ObtentionBac"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .PaysObtentionDuDiplome
                "
                :label="$storeUniversite.label.PaysEtablissement"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                disabled
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
              v-if="
                $storeUniversite.inscription.InfosMaster
                  .PaysObtentionDuDiplome !== $storeCatalogue.DataId.Maroc
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VilleObtentionDuDiplome
                "
                :label="$storeUniversite.label.VilleObtenionDiplome"
                disabled
              ></v-text-field>
            </v-col>
            <v-col v-else cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VilleObtentionDuDiplome
                "
                item-text="lang00"
                item-value="lang00"
                :items="$storeCatalogue.VilleMaroc"
                :label="$storeUniversite.label.VilleObtenionDiplome"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.NomEtablissement
                "
                :label="$storeUniversite.label.NomEtablissementMaster"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosMaster.PublicPrive"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.TypeEtablissementPublicPrive"
                :label="$storeUniversite.label.TypeEtablissement"
                disabled
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosMaster.Majeure"
                :label="$storeUniversite.label.Major"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    dense
                    v-model="myDateFormated3"
                    :label="$storeUniversite.label.DateEntreeLicence"
                    prepend-icon="mdi-calendar"
                    disabled />
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                disabled
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    dense
                    v-model="myDateFormated2"
                    :label="$storeUniversite.label.DateFin"
                    prepend-icon="mdi-calendar"
                    disabled
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VotreEchelleDeNotation
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.BaremBac"
                :label="$storeUniversite.label.EchelleNotation"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosMaster
                  .VotreEchelleDeNotation ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VeuillezPreciserVotreEchelleDeNotation
                "
                :label="$storeUniversite.label.EchelleNotationPrecision"
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="
                $storeUniversite.inscription.InfosMaster
                  .VotreEchelleDeNotation ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <p>
                {{ $storeUniversite.label.Abcd }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.NoteFinaleDuDiplome
                "
                :label="$storeUniversite.label.NoteFinalDiplome"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"> 
              <v-autocomplete
                v-if="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.BacPlus2 ||
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.PrepaScientifique ||
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.PrepaGrandeEcole
                "
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .SystemeNotationPostBac
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.SystemeNotationPostBac"
                :label="$storeUniversite.label.SystemeNotationPostBac"
                disabled
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel
        ref="notesetudessup"
        v-if="
          $storeUniversite.inscription.InfosMaster
            .VotreDiplomeActuelEnCoursOuObtenu != null
        "
      >
        <v-expansion-panel-header>
          <h3>{{ $storeUniversite.label.NoteMasterEtProgIngenieur }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- SEMESTRE 1 & 2 -->
          <v-row>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem1NoteFinale
                "
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.Semestre1
                    : $storeUniversite.label.A1TrimSem1
                "
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem1NbDeRattrapage
                "
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.NbrRattrapages1
                    : $storeUniversite.label.A1NBDeRattrapageTrimSem1"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem2NoteFinale
                "
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.Semestre2
                    : $storeUniversite.label.A1TrimSem2"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.NbrRattrapages2
                    : $storeUniversite.label.A1NBDeRattrapageTrimSem2"
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem2NbDeRattrapage
                "
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="($storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.BacPlus2 ||
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.PrepaScientifique ||
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.PrepaGrandeEcole)
                && $storeUniversite.inscription.InfosMaster.SystemeNotationPostBac !=
              $storeCatalogue.DataId.SystemeNotationPostBacSemestriel">
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Annee1TRIM3
                "
                :label="$storeUniversite.label.Trimestre3"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Annee1Trim3NBDeRattrapage
                "
                :label="$storeUniversite.label.NBDeRattrapage13"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- SEMESTRE 3 & 4 -->
          <v-row>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem3NoteFinale
                "
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.Semestre3
                    : $storeUniversite.label.A2TrimSem1"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem3NbDeRattrapage
                "
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.NbrRattrapages3
                    : $storeUniversite.label.A2NBDeRattrapageTrimSem1"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem4NoteFinale
                "
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.Semestre4
                    : $storeUniversite.label.A2TrimSem2"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem4NbDeRattrapage
                "
                :label="$storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.BacPlus2 &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaScientifique &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu !=
                        $storeCatalogue.DataId.PrepaGrandeEcole &&
                        $storeUniversite.inscription.InfosMaster
                        .VotreDiplomeActuelEnCoursOuObtenu != null
                      ? $storeUniversite.label.NbrRattrapages4
                    : $storeUniversite.label.A2NBDeRattrapageTrimSem2"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="($storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.BacPlus2 ||
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.PrepaScientifique ||
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.PrepaGrandeEcole)
                && $storeUniversite.inscription.InfosMaster.SystemeNotationPostBac !=
              $storeCatalogue.DataId.SystemeNotationPostBacSemestriel">
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Annee2Trim3
                "
                :label="$storeUniversite.label.Trimestre23"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Annee2Trim3NBDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages23"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- SEMESTRE 5 & 6 -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null
            "
          >
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem5NoteFinale
                "
                :label="$storeUniversite.label.Semestre5"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem5NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages5"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem6NoteFinale
                "
                :label="$storeUniversite.label.Semestre6"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem6NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages6"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- SEMESTRE 7 & 8  -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus3 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null
            "
          >
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem7NoteFinale
                "
                :label="$storeUniversite.label.Semestre7"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem7NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages7"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem8NoteFinale
                "
                :label="$storeUniversite.label.Semestre8"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem8NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages8"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Informations MASTER/INGENIEUR -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus3 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus4 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null &&
              $storeUniversite.inscription.NiveauDEtude.indexOf(
                $storeCatalogue.DataId.PostBac
              ) < 0
            "
          >
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem9NoteFinale
                "
                :label="$storeUniversite.label.Semestre9"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem9NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages9"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem10NoteFinale
                "
                :label="$storeUniversite.label.Semestre10"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem10NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages10"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus3 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus4 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus5 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null &&
              $storeUniversite.inscription.NiveauDEtude.indexOf(
                $storeCatalogue.DataId.PostBac
              ) < 0
            "
          >
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem11NoteFinale
                "
                :label="$storeUniversite.label.Semestre11"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem11NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages11"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem12NoteFinale
                "
                :label="$storeUniversite.label.Semestre12"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem12NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages12"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="stepper-container">
    <v-row>
      <v-col class="d-flex justify-center">
        <v-btn @click="printSheet">
          {{$storeUniversite.label.ImprimerEtape}}
        </v-btn>
      </v-col>
    </v-row>
    </div>
  </v-form>
</template>
<script>
export default {
  data() {
    return {
      $storeUniversite: this.$storeUniversite,
      $storeCatalogue: this.$storeCatalogue,
      Panel:{
        Principal:[0,1,2,3,4,5],
        EtudesSuperieures:[0,1]
      }
    };
  },
  computed: {
    myDateFormated() {
      return this.formatDate(this.$storeUniversite.inscription.DateDeNaissance);
    },
    myDateFormated2() {
      return this.formatDate(
        this.$storeUniversite.inscription.InfosMaster.DateDeFinOuEspere
      );
    },
    myDateFormated3() {
      return this.formatDate(
        this.$storeUniversite.inscription.InfosMaster.DateEntree
      );
    },
    columnValue() {
      return this.$storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                this.$storeCatalogue.DataId.BacPlus2 ||
              this.$storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                this.$storeCatalogue.DataId.PrepaScientifique ||
              this.$storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                this.$storeCatalogue.DataId.PrepaGrandeEcole ? 6 : 3
    }
  },
  mounted() {
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    // Imprimer l'étap de résumé
    printSheet(){
      // Lancer l'impression
      window.print();
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/InscriptionUniversite.css";
</style>
